// extracted by mini-css-extract-plugin
module.exports = {"Root":"Sketch_Root__37Kzt","View":"Sketch_View__3GrU4","Component":"Sketch_Component__3mj0T"};